import moment from 'moment';

import templateUrl from './employee-timekeeping-audit-log.component.html';
import { AuditLogHistoryEntryModal } from './audit-log-entry-history-modal.component';

export const EmployeeTimekeepingAuditLogComponent = {
    controller: EmployeeTimekeepingAuditLogController,
    controllerAs: "vm",
    templateUrl
};

function EmployeeTimekeepingAuditLogController($uibModal, $q, auditLogService, utilityService,
    apexApiUrl) {
    'ngInject';
    const vm = this;
    vm.auditLogs;
    vm.selectedAuditLog;
    vm.employeeLimit = 25;

    vm.onSelectAuditLog = onSelectAuditLog;
    vm.onInitAuditLog = onInitAuditLog;
    vm.onViewHistory = onViewHistory;
    vm.exportAuditLogs = exportAuditLogs;
    vm.pageSize = 10;
    vm.pageNumber = 1;
    vm.onChangePage = onChangePage;
    vm.onChangeSearchText = onChangeSearchText;
    loadPageData();
    vm.searchText = "";
    return;

    //////////

    function loadPageData() {
        utilityService.showLoading();
        retrieveEmployeeTimekeepingAuditLogs()
            .then(function (auditLogs) {
                vm.auditLogs = auditLogs.Entities;
                vm.totalEntries = auditLogs.TotalEntityCount;
            })
            .catch(function (ex) {
                console.error(ex);
            })
            .then(utilityService.hideLoading);
    }

    function onSelectAuditLog(companyAuditLogs) {
        vm.selectedAuditLog = companyAuditLogs;
    }

    function onInitAuditLog(auditLog) {
        loadEmployeeTimeEntryAuditLogEntries(auditLog)
            .catch(function (ex) {
                console.error(ex);
            });
    }

    function retrieveEmployeeTimekeepingAuditLogs() {
        return auditLogService.retrieveEmployeeTimekeepingAuditLogsPage(vm.pageNumber - 1, {
            PageSize: vm.pageSize,
            CorporationName: vm.searchText
        })
    }

    function onViewHistory(timeEntry) {
        // Open a modal to display the time entry history.
        $uibModal.open({
            ...AuditLogHistoryEntryModal,
            resolve: {
                auditLogEntry: () => timeEntry,
                title: () => "Changes to Time Entry"
            }
        })
    }

    function loadEmployeeTimeEntryAuditLogEntries(auditLog) {
        if (auditLog.TimeEntries) {
            return $q.when(auditLog);
        }
        return auditLogService.retrieveEmployeeTimekeepingAuditLog(auditLog.Employee.Id)
            .then(function (auditLogEntries) {
                if (auditLogEntries === null) {
                    auditLog.TimeEntries = [];
                } else {
                    auditLog.TimeEntries = auditLogEntries.TimeEntries.map(p => ({
                        ...p,
                        History: p.History.map(q => ({
                            ...q,
                            OldValueData: q.__moment ? formatTimeChange(q.__moment.OldValueData) : q.OldValueData,
                            NewValueData: q.__moment ? formatTimeChange(q.__moment.NewValueData) : q.NewValueData
                        }))
                    }));
                }
                return auditLog;
            });
    }

    function onChangePage(pageNumber) {
        vm.selectedAuditLog = null;
        vm.pageNumber = pageNumber;
        loadPageData();
    }

    function onChangeSearchText(text) {
        vm.selectedAuditLog = null;
        vm.searchText = text;
        loadPageData();
    }

    function exportAuditLogs() {
        window.location.href = `${apexApiUrl}/audit-logs/timekeeping/`
            + `${vm.selectedAuditLog.IcdCorporation.IcdCorporationID}.csv`;
    }

    function formatTimeChange(momentTime) {
        return moment.parseZone(momentTime)
            .format("hh:mm a Z")
    }
}
